import parse from 'html-react-parser';
// ##### 25-04-18 Komarov
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../hooks/useLocalizedText.js';
import { Link, Redirect } from 'react-router-dom';
import { login } from '../../../Redux/actions/auth';
// ##### 25-04-24 Komarov
import { setDevMode } from '../../../Redux/actions';
import isDeveloperLogin from '../../../helpers/isDeveloperLogin';

// ##### Komarov 2025-07-14
const Login = props => {
  // ##### Komarov 2025-08-05
  const Password = useLocalizedText('password');
  const sign_in = useLocalizedText('sign_in');
  const NoAccountQuestion = useLocalizedText('NoAccountQuestion');
  const Register = useLocalizedText('Register');
  const Username = useLocalizedText('username');

  const { text } = props;
  // ##### 25-04-24 Komarov
  const devMode = useSelector(state => state.devMode);

  // ##### 25-04-18 Komarov
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const { isLoggedIn } = useSelector(state => state.auth);
  const { message } = useSelector(state => state.message);
  const locale = useSelector(state => state.language);
  const dispatch = useDispatch();

  const validateForm = () => {
    const newErrors = {};
    if (!formData.username.trim()) {
      newErrors.username = Username;
    }
    if (!formData.password.trim()) {
      newErrors.password = Password;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleLogin = async e => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    // ##### 25-04-24 Komarov
    const devCheck = await isDeveloperLogin(
      formData.username,
      formData.password
    );
    if (devCheck) {
      // TODO: Сделать это значение в localStorage согласно постановке
      localStorage.setItem(
        'devKey',
        `${formData.password}+${formData.username}`
      );
      // ##### Komarov 2025-08-26
      // Устанавливаем cookie для серверной отладки
      // Срок 7 дней, доступно на всём сайте
      document.cookie = `devMode=1; Path=/; Max-Age=604800`;
      dispatch(setDevMode());
      return;
    }

    setLoading(true);

    try {
      await dispatch(login(formData.username, formData.password));
      if (mountedRef.current) {
        props.history.push('/');
      }
    } catch (error) {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  };

  if (isLoggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <div data-component="Login">
      <h3>{parse(text)}</h3>
      <div className="col-md-12">
        <div
          className="card card-container"
          style={{
            backgroundColor: '#f7f7f7',
            position: 'relative',
          }}
        >
          {devMode && (
            <div
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                backgroundColor: '#ff4444',
                color: 'white',
                padding: '2px 6px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: 'bold',
              }}
            >
              inDev
            </div>
          )}

          <img
            src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
            alt="profile-img"
            className="profile-img-card"
          />

          <form onSubmit={handleLogin}>
            <div>
              <label className="login-label" htmlFor="username">
                {Username}
                <sup>*</sup>
              </label>
              <input
                type="text"
                className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                name="username"
                value={formData.username}
                onChange={handleInputChange}
              />
              {errors.username && (
                <div className="alert alert-danger" role="alert">
                  {errors.username}
                </div>
              )}
            </div>

            <div>
              <label className="login-label" htmlFor="password">
                {Password}
                <sup>*</sup>
              </label>
              <input
                type="password"
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                name="password"
                value={formData.password}
                onChange={handleInputChange}
              />
              {errors.password && (
                <div className="alert alert-danger" role="alert">
                  {errors.password}
                </div>
              )}
            </div>

            <div>
              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={loading}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm" />
                )}
                <span style={{ color: 'white', fontWeight: 'bold' }}>
                  {sign_in}
                </span>
              </button>
            </div>

            <div>{NoAccountQuestion}</div>

            <div>
              <Link to={`/${locale}/sign_up`}>{Register}</Link>
            </div>

            {message && (
              <div>
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

// ##### 25-05-02 Komarov
export default Login;
